export default {"src":"/_next/static/media/8-icon.fc43a215.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};